var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Delete\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,3.7001953 L20,5.1005859 L18.5,5.1005859 L18.5,20 L1.5,20 L1.5,5.1005859 L0,5.1005859 L0,3.6875 L5,3.6875 L5,0 L15,0 L15,3.7001953 L20,3.7001953 Z M17,18.5 L17,5.1005859 L3,5.1005859 L3,18.5 L17,18.5 Z M6.4003906,1.5 L6.4003906,3.7001953 L13.4003906,3.7001953 L13.4003906,1.5 L6.4003906,1.5 Z M5.5,8.4003906 L7,8.4003906 L7,15.9003906 L5.5,15.9003906 L5.5,8.4003906 Z M9.25,8.4003906 L10.75,8.4003906 L10.75,15.9003906 L9.25,15.9003906 L9.25,8.4003906 Z M13,8.4003906 L14.5,8.4003906 L14.5,15.9003906 L13,15.9003906 L13,8.4003906 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4b8ecf0c5ee5f4bdaacfd0829597d37c.svg";
export { ForwardRef as ReactComponent };